import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig, AboutPageViewModel } from 'src/environments/environment.interface';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  facilityConfig: FacilityConfig;
  vm: AboutPageViewModel | null = null;
  aboutContent: SafeHtml | null = null;
  isLoading = true;
  hasError = false;
  useComponents = false;

  constructor(
    private _environmentService: EnvironmentService,
    private _http: HttpClient,
    private _sanitizer: DomSanitizer,
    private _title: Title
  ) {
    this.facilityConfig = this._environmentService.getFacilityConfig();
  }

  ngOnInit(): void {
    const aboutPage = this.facilityConfig.aboutPage;

    if (!aboutPage?.show) {
      this.hasError = true;
      this.isLoading = false;
      return;
    }

    this._title.setTitle(`About — ${this.facilityConfig.name}`);

    // Prefer structured sections (component-wise)
    if (aboutPage.sections?.hero) {
      this.vm = aboutPage.sections;
      this.useComponents = true;
      this.isLoading = false;
      return;
    }

    // Legacy: inline content
    if (aboutPage.content) {
      this.aboutContent = this._sanitizer.bypassSecurityTrustHtml(aboutPage.content);
      this.isLoading = false;
      return;
    }

    // Legacy: fetch from URL
    if (aboutPage.contentUrl) {
      this._http.get(aboutPage.contentUrl, { responseType: 'text' }).subscribe({
        next: (html) => {
          this.aboutContent = this._sanitizer.bypassSecurityTrustHtml(html);
          this.isLoading = false;
        },
        error: () => {
          this.hasError = true;
          this.isLoading = false;
        }
      });
      return;
    }

    this.hasError = true;
    this.isLoading = false;
  }
}
